import React, { useState } from 'react';
import { useData, DOCTOR_INFO } from '../context/DataContext';

const LoginPage = ({ onLogin, onBack }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
const [loading, setLoading] = useState(false);
const [selectedRole, setSelectedRole] = useState(null);
  const { authenticateUser } = useData();

  const roles = [
    { id: 'receptionist', title: 'Receptionist', icon: '👩‍💼', desc: 'Website Management, News & Slider' },
    { id: 'admin', title: 'Admin', icon: '⚙️', desc: 'Patient Records, Bills & Birth Certificates' },
    { id: 'doctor', title: 'Doctor / Nurse', icon: '👩‍⚕️', desc: 'Patient Care & Medical Records' },
    { id: 'lab', title: 'Lab Technician', icon: '🔬', desc: 'Upload & Manage Lab Reports' },
    { id: 'finance', title: 'Finance', icon: '💰', desc: 'Income & Expense Management' },
  ];
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const response = await fetch('https://api.ruqqiasultanaclinic.com/api/Patient/password/verify', {
        method: 'POST',
        headers: {
          'accept': '*/*',
          'X-API-TOKEN': 'A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2A9F3C8D1E7B4F6A2C9E1D8B7F4A6C5E2',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: 0, role: selectedRole, salt: username, password: password }),
      });
      const data = await response.json();
      if (response.ok && data.message === 'Login successful') {
        const user = authenticateUser(username, password) || { username, name: username, role: selectedRole };
        onLogin({ ...user, role: data.role || selectedRole });
     } else {
        setError('Invalid credentials');
      }
   } catch (err) {
      // fallback to local auth
      const user = authenticateUser(username, password);
      if (user) {
        if (selectedRole && user.role !== selectedRole) { setError('Invalid credentials for this role'); setLoading(false); return; }
        onLogin(user);
      } else {
        setError('Invalid username or password');
      }
    } finally {
      setLoading(false);
    }
  };
  if (!selectedRole) {
    return (
      <div className="min-h-screen bg-gradient-light flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <div className="text-center mb-8">
            <img src="/logo.svg" alt="Logo" className="w-20 h-20 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 font-heading">{DOCTOR_INFO.clinicName}</h1>
            <p className="text-blue-600 font-medium mt-1">Staff Login Portal</p>
          </div>
          
          <div className="space-y-4">
            {roles.map((role) => (
              <button key={role.id} onClick={() => setSelectedRole(role.id)}
                className="w-full card p-6 text-left hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-center gap-4">
                  <span className="text-4xl">{role.icon}</span>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">{role.title}</h3>
                    <p className="text-gray-500 text-sm">{role.desc}</p>
                  </div>
                </div>
              </button>
            ))}
          </div>
          
          <button onClick={onBack} className="w-full mt-6 py-3 text-gray-600 hover:text-blue-600 transition-colors">
            ← Back to Website
          </button>
          
          {/* <div className="mt-8 p-4 bg-blue-50 rounded-xl">
            <p className="text-sm text-blue-800 font-medium mb-2">Demo Credentials:</p>
            <p className="text-xs text-blue-600">Receptionist: reception / reception123</p>
            <p className="text-xs text-blue-600">Admin: admin / admin123</p>
            <p className="text-xs text-blue-600">Doctor/Nurse: doctor / doctor123</p>
            <p className="text-xs text-blue-600">Lab: lab / lab123</p>
          </div> */}
        </div>
      </div>
    );
  }

  const currentRole = roles.find(r => r.id === selectedRole);

  return (
    <div className="min-h-screen bg-gradient-light flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="card p-8">
          <div className="text-center mb-8">
            <span className="text-5xl mb-4 block">{currentRole.icon}</span>
            <h1 className="text-2xl font-bold text-gray-900 font-heading">{currentRole.title} Login</h1>
          </div>
          
          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm">{error}</div>
          )}
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Username</label>
              <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="input-field" placeholder="Enter username" required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" placeholder="Enter password" required />
            </div>
<button type="submit" disabled={loading} className={`w-full btn-primary py-3 flex items-center justify-center gap-2 transition-all ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}>
  {loading ? (
    <>
      <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
      </svg>
      Verifying...
    </>
  ) : 'Login'}
</button>          </form>
          
          <button onClick={() => setSelectedRole(null)} className="w-full mt-4 py-3 text-gray-600 hover:text-blue-600 transition-colors">
            ← Choose Different Role
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
